// Basic
import PropTypes from 'prop-types';
// Store & actions
import actionsSession from '@/app/modules/session/api/actionsSession';
// Common
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import { ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterConfirmation from '@/common-utils/components/renders/modal/components/footers/FooterConfirmation/FooterConfirmation';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
// Css
import './ContentConfirmActionMFA.scss';
import { nsSession } from '@/app/i18n/namespaces';

/**
 * @param {function} setIsOpen
 * @param {Object} showModalsetters
 * @param {boolean} isCancelClicked
 *@returns {JSX}
 */
function ContentConfirmActionMFA({ onClose, showModalSetters, isCancelClicked }) {
    // Props destructuring
    const { setShowContentConfirmActionMFA, setShowContentSetMFA, setShowModalRemoveMFA } = showModalSetters;

    // API call
    const {
        data: hasMfa,
        isFetching,
        isError
    } = actionsSession.getMfa();

    // Functions
    const handleValidateButton = () => {
        setShowContentConfirmActionMFA(false);
        if (hasMfa) {
            setShowModalRemoveMFA(true);
        }
        else {
            setShowContentSetMFA(true);
        }
        onClose();
    };

    return (
        <ModalContent className={cn('max-w-3xl', 'modal-secure-access')}>
            <HeaderTitle title='mfa.init_title' namespace={nsSession} />
            <ModalBody>
                {isFetching &&
                    <Spinner className='panel-spinner' />
                }
                {!isFetching &&
                    <div className='update-mfa-warning'>
                        {isCancelClicked &&
                            <Entity namespace={nsSession} entity='mfa.cancel_message' />
                        }
                        {!isCancelClicked && isError &&
                            (
                                <Entity namespace={nsSession} entity='mfa.fetch_error' />
                            )
                        }
                        {!isCancelClicked && !isError &&
                            (
                                <Entity
                                    namespace={nsSession}
                                    entity={hasMfa ? 'mfa.confirm_deactivation_message' : 'mfa.confirm_activation_message'}
                                />
                            )
                        }
                    </div>
                }
            </ModalBody>
            {isCancelClicked || isError ?
                <FooterForm
                    showSubmitButton={false}
                />
                :
                <FooterConfirmation
                    onValidation={handleValidateButton}
                    isSubmitDisabled={isFetching}
                />
            }
        </ModalContent>
    );
}

ContentConfirmActionMFA.propTypes = {
    onClose: PropTypes.func,
    showModalSetters: PropTypes.shape({
        setShowContentConfirmActionMFA: PropTypes.func,
        setShowContentSetMFA: PropTypes.func,
        setShowModalRemoveMFA: PropTypes.func
    }),
    isCancelClicked: PropTypes.bool
};

export default ContentConfirmActionMFA;